<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <span>Event Details</span>
    </div>
  </kendo-dialog-titlebar>

  <div class="p-12 pt-0">
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 12, cols: 0}" [cols]="['repeat(4,minmax(0,1fr))']">
      <kendo-gridlayout-item class="mb-0">
        <h6>
          <small>Subject</small>
        </h6>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [colSpan]="3" class="mb-0">
        <p class="font-weight600">{{ event?.title || '-' }}</p>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item class="mb-0">
        <h6>
          <small>Start</small>
        </h6>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [colSpan]="3" class="mb-0">
        <p class="font-weight600">{{ event?.start | date: 'MM/dd/yyyy hh:mm a' }}</p>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item class="mb-0">
        <h6>
          <small>End</small>
        </h6>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [colSpan]="3" class="mb-0">
        <p class="font-weight600">{{ event?.end | date: 'MM/dd/yyyy hh:mm a' }}</p>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item class="mb-0" *ngIf="parsedContent">
        <h6>
          <small>Description</small>
        </h6>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [colSpan]="3" class="mb-0" *ngIf="parsedContent">
        <p class="font-weight600 event-body-content">{{ parsedContent }}</p>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>
</div>
